import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AnnouncementBar from "./AnnouncementBar";
import CountdownBar from "./CountdownBar";
import FloatingWhatsApp from "./FloatingWhatsApp";
import { useSettings } from "../lib/settings";

export default function PublicLayout() {
  const settings = useSettings();
  return (
    <div className="min-h-screen flex flex-col">
      {settings.countdown_active !== false && <CountdownBar />}
      <AnnouncementBar />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
